<div class="logo-container">
	<img class="img" src="/assets/img/dropbox-sign-plus-procore.jpg" />
</div>

<div *ngIf="!authError && !authMessage" class="loading-container" role="status" id="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<div class="text-container" *ngIf="authMessage">
	{{ authMessage }}
</div>

<div class="text-container" *ngIf="authError">
	Your browser is potentially blocking popups. Please turn off any popup blockers and refresh the page.
</div>